import React from 'react';
import Menu from '@mui/material/Menu';
import {map} from 'lodash';
import Box from '@mui/material/Box';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';

const HeaderDropdown = ({menuItem}) => {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const {t} = useTranslation();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return <div>
    <div
        onClick={handleClick}
    >
      <Box style={{
        cursor: "pointer",
        display: "flex",
        margin: "auto",
        justifyContent: "center",
        justifyItems: "center"
      }}>
        {t(menuItem.label)}
        <span style={{marginTop: 5}}><ArrowDropDownIcon style={{fontSize: 18}}/></span>
      </Box>
    </div>
    <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
    >
      {
        map(menuItem.subMenu, item => <Box key={item.uiKey} m={1}>
          <a href={item.link} style={{color: '#1a2126', textDecoration: 'none'}} target="_blank">
            {t(item.label)}
          </a>
        </Box>)
      }
    </Menu>
  </div>
}

export default HeaderDropdown;
